import React from 'react'
import { Modal, ModalNavHeader, FlexRow, Button, FlexColumn } from 'elements'
import { useAuth } from 'hooks'
import ChoiceButton from 'components/ui/input/ChoiceButton'

export default function SelectUploadSource({ modal, selected, onChange, onNext, onBack }) {
  const { currentCompany } = useAuth()

  const handleContinue = () => {
    if (selected?.href) {
      window.location.href = selected.href
    } else {
      onNext()
    }
  }

  // this loads at the start so should be available first thing,
  // but sometimes with deep linking this modal tries to open before
  // the current company has been loaded
  if (!currentCompany) {
    return null
  }

  const modalActions = [
    {
      label: 'Help',
      value: 'help',
      onSelect: () => window.open('https://scrutinize.io/howitworks', '_blank'),
    },
  ]

  return (
    <>
      <ModalNavHeader
        onClose={modal.onClose}
        onBack={onBack}
        actionOptions={modalActions}
        titleText="Create Report"
      />
      <FlexColumn p="xxlarge" pt="large" pb="xgigantic">
        <FlexRow mb="large">
          <ChoiceButton
            icon="document-add"
            selected={selected === 'qbo'}
            onPress={() => onChange('qbo')}
          >
            QuickBooks® Online
          </ChoiceButton>
        </FlexRow>

        <FlexRow mb="large">
          <ChoiceButton
            icon="document-add"
            selected={selected === 'desktop'}
            onPress={() => onChange('desktop')}
          >
            QuickBooks® Desktop
          </ChoiceButton>
        </FlexRow>
      </FlexColumn>
      <Modal.Footer display="flex" alignItems="center">
        <Button mr="medium" kind="secondary" onPress={handleContinue}>
          Continue
        </Button>
        <Button onPress={modal.onClose} mr="xxxlarge">
          Cancel
        </Button>
      </Modal.Footer>
    </>
  )
}
